import { render } from "./TheFooter.vue?vue&type=template&id=6728af2e&scoped=true"
const script = {}

import "@/assets/styles/footer.scss?vue&type=style&index=0&id=6728af2e&lang=scss&scoped=true"

import exportComponent from "/home/djokic/Projects/mariv/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6728af2e"]])

export default __exports__